import React, { useState, useMemo } from 'react';
import Select from 'react-select';
import countryList from 'react-select-country-list';
import Flags from 'country-flag-icons/react/3x2';

function CountrySelector({ value, onChange, required }) {
  // Get country list once using useMemo
  const options = useMemo(() => {
    return countryList().getData().map(country => ({
      label: country.label,
      value: country.value,
    }));
  }, []);

  // Custom option component to display flag next to country name
  const CountryOption = ({ innerProps, data }) => {
    const countryCode = data.value.toUpperCase();
    // Check if the flag component exists for this country code
    const Flag = Flags[countryCode];
    
    return (
      <div {...innerProps} className="country-option">
        {Flag && <Flag className="country-flag" style={{ width: '20px', marginRight: '8px' }} />}
        <span>{data.label}</span>
      </div>
    );
  };

  // Custom selected value component
  const SingleValue = ({ children, data }) => {
    const countryCode = data.value.toUpperCase();
    // Check if the flag component exists for this country code
    const Flag = Flags[countryCode];
    
    return (
      <div className="single-value-container">
        {Flag && <Flag className="country-flag" style={{ width: '20px', marginRight: '8px' }} />}
        <span>{children}</span>
      </div>
    );
  };

  return (
    <Select
      options={options}
      value={value ? options.find(option => option.value === value) : null}
      onChange={onChange}
      required={required}
      placeholder="Select a country"
      components={{ Option: CountryOption }}
      styles={{
        control: (base) => ({
          ...base,
          minHeight: '38px',
        }),
        option: (base, state) => ({
          ...base,
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          backgroundColor: state.isSelected ? '#3182ce' : state.isFocused ? '#e2e8f0' : 'white',
          color: state.isSelected ? 'white' : 'black',
        }),
        singleValue: (base) => ({
          ...base,
          display: 'flex',
          alignItems: 'center',
        }),
      }}
    />
  );
}

export default CountrySelector;